import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SelfMapObjectKeys } from '@cm/utility';

const labelDescriptionStart = 'Label for: ';
const displayPathStart = 'Catalogs|Benefits|';
const sharedLocProperties: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Benefit,
};

export type BenefitCatalogLocs =
	| 'SPBenefitCatalogLabelGroup'
	| 'SPBenefitCatalogLabelName'
	| 'SPBenefitCatalogLabelType'
	| 'SPBenefitCatalogLabelGrantType'
	| 'SPBenefitCatalogLabelClaimEndDate'
	| 'SPBenefitCatalogLabelViewEndDate'
	| 'SPBenefitCatalogTitleSection'
	| 'SPBenefitCatalogTitlePage'
	| 'SPBenefitCatalogButtonViewTokenCounts'
	| 'SPBenefitCatalogLabelFilterByGroup'
	| 'SPBenefitCatalogLabelFilterByType';

export const benefitCatalogLocs: LocDefs<BenefitCatalogLocs> = {
	SPBenefitCatalogButtonViewTokenCounts: {
		defaultValue: 'View Token Counts',
		displayType: 'Button',
		description: 'View token counts button',
		displayPath: `${displayPathStart}View Token Counts`,
		...sharedLocProperties,
	},
	SPBenefitCatalogTitlePage: {
		defaultValue: 'Benefit Catalog',
		displayType: 'Title',
		description: 'Page title',
		displayPath: `${displayPathStart}Page Title`,
		...sharedLocProperties,
	},
	SPBenefitCatalogTitleSection: {
		defaultValue: 'Benefits',
		displayType: 'Title',
		description: 'Section title',
		displayPath: `${displayPathStart}Section Title`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		displayType: 'Label',
		description: `${labelDescriptionStart} Filter by Group`,
		displayPath: `${displayPathStart}Filter by Group`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelFilterByType: {
		defaultValue: 'Filter by Type',
		displayType: 'Label',
		description: `${labelDescriptionStart} Filter by Type`,
		displayPath: `${displayPathStart}Filter by Type`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelGroup: {
		defaultValue: 'Group',
		displayType: 'Label',
		description: `${labelDescriptionStart} Group`,
		displayPath: `${displayPathStart}Group`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelName: {
		defaultValue: 'Name',
		displayType: 'Label',
		description: `${labelDescriptionStart} Name`,
		displayPath: `${displayPathStart}Name`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelType: {
		defaultValue: 'Type',
		displayType: 'Label',
		description: `${labelDescriptionStart} Type`,
		displayPath: `${displayPathStart}Type`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelGrantType: {
		defaultValue: 'Grant Type',
		displayType: 'Label',
		description: `${labelDescriptionStart} Grant Type`,
		displayPath: `${displayPathStart}Grant Type`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelClaimEndDate: {
		defaultValue: 'Claim End Date',
		displayType: 'Label',
		description: `${labelDescriptionStart} Claim End Date`,
		displayPath: `${displayPathStart}Claim End Date`,
		...sharedLocProperties,
	},
	SPBenefitCatalogLabelViewEndDate: {
		defaultValue: 'View End Date',
		displayType: 'Label',
		description: `${labelDescriptionStart} View End Date`,
		displayPath: `${displayPathStart}View End Date`,
		...sharedLocProperties,
	},
};

export const LOC_KEYS = SelfMapObjectKeys(benefitCatalogLocs);
export type SPBenefitCatalogLocsType = LocMap<BenefitCatalogLocs>;
